export class Immutable {
    #original;
    #modified = undefined;
    #clone;
    // The clone function is called (at most once) on the first update. It defaults to a deep
    // clone; pass a cheaper cloner when you know which parts of the value the updaters touch.
    constructor(value, clone = structuredClone) {
        this.#original = value;
        this.#clone = clone;
    }
    value() {
        return this.#modified ?? this.#original;
    }
    update(updater) {
        this.#modified ??= this.#clone(this.#original);
        updater(this.#modified);
    }
}
